// import React, { useState } from "react";
// import { Button, Upload, message, Modal } from "antd";
// import { FileAddOutlined, UploadOutlined, InboxOutlined, FileImageOutlined } from "@ant-design/icons";

// const { Dragger } = Upload;

// const UploadProgramContent = () => {
//     const [modalVisible, setModalVisible] = useState(false);
//     const [uploadType, setUploadType] = useState(null);

//     const showModal = (type) => {
//         setUploadType(type);
//         setModalVisible(true);
//     };

//     const handleModalClose = () => {
//         setModalVisible(false);
//         setUploadType(null);
//     };

//     const getUploadProps = () => {
//         let acceptTypes = "";
//         let descriptionText = "";

//         if (uploadType === "programKits") {
//             acceptTypes = ".pdf,.doc,.docx,.xls,.xlsx";
//             descriptionText = "Upload your program kit documents here.";
//         } else if (uploadType === "promotionalKits") {
//             acceptTypes = ".jpg,.jpeg,.png,.gif,.pdf,.mp4";
//             descriptionText = "Upload your promotional materials (images, videos, PDFs) here.";
//         } else if (uploadType === "picVID") {
//             acceptTypes = ".jpg,.jpeg,.png,.mp4";
//             descriptionText = "Upload your program photos and videos (images, videos) here.";
//         }

//         const props = {
//             name: "file",
//             multiple: true,
//             action: "https://www.mocky.io/v2/5cc8019d300000980a055e76", // Replace with your actual upload API endpoint
//             accept: acceptTypes,
//             onChange(info) {
//                 const { status } = info.file;
//                 if (status === "done") {
//                     message.success(`${info.file.name} file uploaded successfully.`);
//                 } else if (status === "error") {
//                     message.error(`${info.file.name} file upload failed.`);
//                 }
//             },
//         };

//         return { props, descriptionText };
//     };

//     const { props, descriptionText } = getUploadProps();

//     return (
//         <div style={{ padding: '40px', maxWidth: '800px', margin: 'auto', textAlign: 'center' }}>
//             <h1 style={{ marginBottom: '30px' }}>Upload Program Content</h1>
//             <p style={{ marginBottom: '40px' }}>
//                 Please select the type of content you would like to upload.
//             </p>

//             <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
//                 <Button
//                     type="primary"
//                     icon={<FileAddOutlined style={{ fontSize: "32px" }} />}
//                     onClick={() => showModal("programKits")}
//                     style={{ height: 'auto', padding: '20px 30px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minWidth: "250px" }}
//                 >
//                     <span style={{ fontSize: '18px', marginTop: '8px' }}>Upload Program Kits</span>
//                 </Button>
//                 <Button
//                     type="primary"
//                     icon={<UploadOutlined style={{ fontSize: "32px" }} />}
//                     onClick={() => showModal("promotionalKits")}
//                     style={{ height: 'auto', padding: '20px 30px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minWidth: "250px" }}
//                 >
//                     <span style={{ fontSize: '18px', marginTop: '8px' }}>Upload Promotional Kits</span>
//                 </Button>
//                 <Button
//                     type="primary"
//                     icon={<FileImageOutlined style={{ fontSize: "32px" }} />}
//                     onClick={() => showModal("picVID")}
//                     style={{ height: 'auto', padding: '20px 30px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minWidth: "250px" }}
//                 >
//                     <span style={{ fontSize: '18px', marginTop: '8px' }}>Upload Program <br />Photos & Videos</span>
//                 </Button>
//             </div>

//             <Modal
//                 title={
//                     uploadType === "programKits"
//                         ? "Upload Program Kits"
//                         : uploadType === "promotionalKits"
//                             ? "Upload Promotional Kits"
//                             : "Upload Program Photos & Videos"
//                 } open={modalVisible}
//                 onCancel={handleModalClose}
//                 footer={null} // Hide the default OK and Cancel buttons
//             >
//                 <p style={{ marginTop: '20px' }}>{descriptionText}</p>
//                 <Dragger {...props}>
//                     <p className="ant-upload-drag-icon">
//                         <InboxOutlined />
//                     </p>
//                     <p className="ant-upload-text">Click or drag file to this area to upload</p>
//                     <p className="ant-upload-hint">Support for a single or bulk upload.</p>
//                 </Dragger>
//             </Modal>
//         </div>
//     );
// };

// export default UploadProgramContent;

import React, { useState } from "react";
import { Upload, message, Modal, Form, Select, Space } from "antd";
import { Button } from "@mui/material";
import { FileAddOutlined, UploadOutlined, InboxOutlined, FileImageOutlined } from "@ant-design/icons";
import { LocalLaundryService } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
const { Dragger } = Upload;
const { Option } = Select;


// New data structure for programs
const programs = [
    {
        title: "Foundational Programs",
        children: [
            { title: "YouWaah" },
            { title: "Anjuli" },
            { title: "Cancer Crusaders" },
            { title: "Career Compass" },
            { title: "Matritva" },
            { title: "Pitru Parv" },
            { title: "Eco Fiesta" },
            { title: "Pratibha Spotlight" },
            { title: "BJS Seed" },
            { title: "Gurudakshina" },
            { title: "Nirvana Nosh" },
            { title: "Chillar Party" },
            { title: "Seva Squad" },
        ],
    },
    {
        title: "Inception Programs",
        children: [
            { title: "B2B Conclave" },
            { title: "Organ Donation" },
            { title: "Khilona Bank" },
            { title: "VidyaDaan" },
        ],
    },
    {
        title: "Infusion Programs",
        children: [
            { title: "Career Canvas" },
            { title: "Su Milan" },
            { title: "Teen Taal" },
            { title: "Mention Knot" },
            { title: "Skills Navigator" },
            { title: "Young Tycoon" },
        ],
    },
    {
        title: "Volunteer Development",
        children: [
            { title: "Volunteer Development Program" },
        ],
    },
    {
        title: "National Programs",
        children: [
            { title: "Disaster Response" },
            { title: "Water Rejuvenation" },
            { title: "Mulyavardhan" },
        ],
    },
];

const UploadProgramContent = () => {
    const [modalVisible, setModalVisible] = useState(false);
    const [uploadType, setUploadType] = useState(null);
    const [form] = Form.useForm();
    const [selectedProgramBasket, setSelectedProgramBasket] = useState(null);

    const theme = useTheme();

    const showModal = (type) => {
        setUploadType(type);
        setModalVisible(true);
    };

    const handleModalClose = () => {
        setModalVisible(false);
        setUploadType(null);
        form.resetFields(); // Reset form fields on modal close
        setSelectedProgramBasket(null); // Reset the selected basket
    };

    const handleProgramBasketChange = (value) => {
        setSelectedProgramBasket(value);
        form.setFieldsValue({ program: undefined }); // Reset the program field when basket changes
    };

    const getUploadProps = () => {
        let acceptTypes = "";
        let descriptionText = "";

        if (uploadType === "programKits") {
            acceptTypes = ".pdf,.doc,.docx,.xls,.xlsx";
            descriptionText = "Upload your program kit documents here.";
        } else if (uploadType === "promotionalKits") {
            acceptTypes = ".jpg,.jpeg,.png,.gif,.pdf,.mp4";
            descriptionText = "Upload your promotional materials (images, videos, PDFs) here.";
        } else if (uploadType === "picVID") {
            acceptTypes = ".jpg,.jpeg,.png,.mp4";
            descriptionText = "Upload your program photos and videos (images, videos) here.";
        }

        const token = localStorage.getItem("accessToken")

        const props = {
            name: "file",
            multiple: true,
            action: `${process.env.REACT_APP_BASE_URL}/upload/document/image`, // Replace with your actual upload API endpoint
            accept: acceptTypes,
            headers: {
                Authorization: `Bearer ${token}`, // Add the Authorization header with the token
            },
            onChange(info) {
                const { status } = info.file;
                if (status === "done") {
                    message.success(`${info.file.name} file uploaded successfully.`);
                } else if (status === "error") {
                    message.error(`${info.file.name} file upload failed.`);
                }
            },
        };

        return { props, descriptionText };
    };

    const { props, descriptionText } = getUploadProps();

    const selectedProgramChildren = programs.find(p => p.title === selectedProgramBasket)?.children || [];



    const handleUpload = async () => {
        try {
            const values = await form.validateFields();
            console.log('Form values:', values);

            // Simulate getting file info from the upload.
            // In a real app, you would get this from the server's response.
            const uploadedFileUrl = 'https://via.placeholder.com/600x400.png?text=Uploaded+Image'; // Placeholder URL

            // Prepare the data to be saved to localStorage
            const mediaItem = {
                url: uploadedFileUrl,
                description: `Uploaded media for ${values.program}`,
                type: uploadType,
            };

            const existingData = JSON.parse(localStorage.getItem('uploadedMedia')) || {};
            const programKey = `${values.programBasket}-${values.program}`;

            if (!existingData[programKey]) {
                existingData[programKey] = [];
            }

            existingData[programKey].push(mediaItem);

            localStorage.setItem('uploadedMedia', JSON.stringify(existingData));

            message.success('Content saved to local storage!');
            handleModalClose();

        } catch (errorInfo) {
            console.log('Validation Failed:', errorInfo);
            message.error('Please complete all required fields before proceeding.');
        }
    };






    return (
        <div
            style={{
                padding: "50px",
                maxWidth: "100%",
                minHeight: "500px",
                margin: "auto",
                background: "#fff",
                borderRadius: "16px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
                alignItems: "center",
                textAlign: "center",
            }}
        >
            <h1 style={{ marginBottom: "10px", fontWeight: 600 }}>Upload Program Content</h1>
            <p style={{ marginBottom: "40px", color: "#555" }}>
                Please select the type of content you would like to upload.
            </p>

            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "25px",
                    flexWrap: "wrap",
                }}
            >
                {[
                    {
                        key: "programKits",
                        icon: <FileAddOutlined style={{ fontSize: "56px" }} />,
                        label: "Upload Program Kits",
                    },
                    {
                        key: "promotionalKits",
                        icon: <UploadOutlined style={{ fontSize: "56px" }} />,
                        label: "Upload Promotional Kits",
                    },
                    {
                        key: "picVID",
                        icon: <FileImageOutlined style={{ fontSize: "56px" }} />,
                        label: "Upload Program Photos & Videos",
                    },
                ].map((btn) => (
                    <Button
                        key={btn.key}
                        type="default"
                        onClick={() => showModal(btn.key)}
                        style={{
                            width: "260px",
                            height: "160px",
                            borderRadius: "14px",
                            border: `1px solid ${theme.palette.primary.main}`,
                            color: theme.palette.secondary.figma,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            background: "#fff",
                            boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
                            transition: "all 0.3s ease",
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.background = theme.palette.secondary.figma;
                            e.currentTarget.style.color = "#fff";
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.background = "#fff";
                            e.currentTarget.style.color = theme.palette.secondary.figma;
                        }}
                    >

                        {btn.icon}
                        <span
                            style={{
                                fontSize: "16px",
                                fontWeight: 500,
                                marginTop: "10px",
                                color: "inherit",
                                textAlign: "center",
                                lineHeight: 1.3,
                            }}
                        >
                            {btn.label}
                        </span>
                    </Button>
                ))}
            </div>

            <Modal
                title={
                    uploadType === "programKits"
                        ? "Upload Program Kits"
                        : uploadType === "promotionalKits"
                            ? "Upload Promotional Kits"
                            : "Upload Program Photos & Videos"
                }
                open={modalVisible}
                onCancel={handleModalClose}
                footer={[
                    <Button key="back" onClick={handleModalClose}>
                        Cancel
                    </Button>,
                    <Button key="submit" type="primary" onClick={handleUpload}>
                        Submit
                    </Button>,
                ]}
            >
                <Form form={form} layout="vertical">
                    <Form.Item
                        name="programBasket"
                        label="Select Program Basket"
                        rules={[{ required: true, message: "Please select a program basket!" }]}
                    >
                        <Select placeholder="Select a basket" onChange={handleProgramBasketChange}>
                            {programs.map((basket) => (
                                <Option key={basket.title} value={basket.title}>
                                    {basket.title}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="program"
                        label="Select Program"
                        rules={[{ required: true, message: "Please select a program!" }]}
                    >
                        <Select placeholder="Select a program" disabled={!selectedProgramBasket}>
                            {selectedProgramChildren.map((program) => (
                                <Option key={program.title} value={program.title}>
                                    {program.title}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Form>

                <p style={{ marginTop: "20px", color: "#666" }}>{descriptionText}</p>

                <Dragger {...props}>
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Click or drag file to this area to upload</p>
                    <p className="ant-upload-hint">Support for single or bulk upload.</p>
                </Dragger>
            </Modal>
        </div>
    );
}





//     return (
//         <div style={{ padding: '40px', maxWidth: '800px', margin: 'auto', textAlign: 'center' }}>
//             <h1 style={{ marginBottom: '30px' }}>Upload Program Content</h1>
//             <p style={{ marginBottom: '40px' }}>
//                 Please select the type of content you would like to upload.
//             </p>

//             <Space size="large">
//                 <Button
//                     type="primary"
//                     icon={<FileAddOutlined style={{ fontSize: "32px" }} />}
//                     onClick={() => showModal("programKits")}
//                     style={{ height: 'auto', padding: '20px 30px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minWidth: "250px" }}
//                 >
//                     <span style={{ fontSize: '18px', marginTop: '8px' }}>Upload Program Kits</span>
//                 </Button>
//                 <Button
//                     type="primary"
//                     icon={<UploadOutlined style={{ fontSize: "32px" }} />}
//                     onClick={() => showModal("promotionalKits")}
//                     style={{ height: 'auto', padding: '20px 30px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minWidth: "250px" }}
//                 >
//                     <span style={{ fontSize: '18px', marginTop: '8px' }}>Upload Promotional Kits</span>
//                 </Button>
//                 <Button
//                     type="primary"
//                     icon={<FileImageOutlined style={{ fontSize: "32px" }} />}
//                     onClick={() => showModal("picVID")}
//                     style={{ height: 'auto', padding: '20px 30px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minWidth: "250px" }}
//                 >
//                     <span style={{ fontSize: '18px', marginTop: '8px' }}>Upload Program <br />Photos & Videos</span>
//                 </Button>
//             </Space>

//             <Modal
//                 title={
//                     uploadType === "programKits"
//                         ? "Upload Program Kits"
//                         : uploadType === "promotionalKits"
//                             ? "Upload Promotional Kits"
//                             : "Upload Program Photos & Videos"
//                 }
//                 open={modalVisible}
//                 onCancel={handleModalClose}
//                 footer={[<Button key="back" onClick={handleModalClose}>
//                     Cancel
//                 </Button>,
//                 <Button
//                     key="submit"
//                     type="primary"
//                     onClick={handleUpload} // This button will trigger the form validation
//                 >
//                     Submit
//                 </Button>]}
//             >
//                 <Form form={form} layout="vertical">
//                     <Form.Item
//                         name="programBasket"
//                         label="Select Program Basket:"
//                         rules={[{ required: true, message: 'Please select a program basket!' }]}
//                     >
//                         <Select
//                             placeholder="Select a basket"
//                             onChange={handleProgramBasketChange}
//                         >
//                             {programs.map((basket) => (
//                                 <Option key={basket.title} value={basket.title}>
//                                     {basket.title}
//                                 </Option>
//                             ))}
//                         </Select>
//                     </Form.Item>
//                     <Form.Item
//                         name="program"
//                         label="Select Program:"
//                         rules={[{ required: true, message: 'Please select a program!' }]}
//                     >
//                         <Select
//                             placeholder="Select a program"
//                             disabled={!selectedProgramBasket}
//                         >
//                             {selectedProgramChildren.map((program) => (
//                                 <Option key={program.title} value={program.title}>
//                                     {program.title}
//                                 </Option>
//                             ))}
//                         </Select>
//                     </Form.Item>
//                 </Form>
//                 <p style={{ marginTop: '20px' }}>{descriptionText}</p>
//                 <Dragger {...props}>
//                     <p className="ant-upload-drag-icon">
//                         <InboxOutlined />
//                     </p>
//                     <p className="ant-upload-text">Click or drag file to this area to upload</p>
//                     <p className="ant-upload-hint">Support for a single or bulk upload.</p>
//                 </Dragger>
//             </Modal>
//         </div>
//     );
// };

export default UploadProgramContent;